import { Controller } from '@hotwired/stimulus'

// This controller allows to manage a list of values that can be toggled on and off from a list of checkboxes
// The values are stored in a hidden input field, separated by commas
// This is useful when the checkboxes are not in the same form as the hidden input field
// or when they are temporary in the DOM (e.g in a turbo-frame powered search form)

// Connects to data-controller="checkbox-state-manager"
export default class extends Controller {
  static targets = ['output', 'checkbox']
  connect () {
  }

  updateCheckboxState (event) {
    const checkbox = event.target
    const value = checkbox.value

    let values = this.parsedValues()
    if (checkbox.checked) {
      values.push(value)
    } else {
      values = values.filter(v => v !== value)
    }

    this.outputTargets.forEach(output => {
      output.value = values.join(',')
      output.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  parsedValues () {
    if (this.outputTarget.value === '') {
      return []
    }

    return this.outputTarget.value.split(',')
  }

  clear (e) {
    this.outputTargets.forEach(output => {
      output.value = ''
      output.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: e.params.detail }))
    })
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }
}
